export const isCodelessEventsApp = () => window.__APP_CONFIG__?.applicationName === 'codeless-events';
